// extracted by mini-css-extract-plugin
export var card = "_45-0";
export var content = "_45-1";
export var contentLoading = "_45-2";